import React from 'react';

export default function withResults(WrappedComponent, flightType) {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        // eslint-disable-next-line react/no-unused-state
        flightType,
      };
    }

    render() {
      return <WrappedComponent flightType={flightType} {...this.props} />;
    }
  };
}
